module.exports = __webpack_public_path__ + "img/hospitium-01.d53a3c5e.jpg";